import VueBaseController from '../vue_base'

export class IndexController extends VueBaseController { // eslint-disable-line import/prefer-default-export
  static get COMPONENT() { return () => import('@/vue/pages/admin/trello_boards/index.vue') }
}
